import { CookieKey, coreNativeModule, type RNCoreNativeModule } from "../types/RNCoreNativeModule";

// DO NOT USE THIS FUNCTION DIRECTLY. USE provider specific getter instead.
function getCookies<K extends CookieKey>(
  cookieNames: readonly K[],
): Promise<Record<K, string | null> | Record<string, never>> {
  return coreNativeModule()?.getCookies?.(cookieNames) ?? Promise.resolve({});
}

// cookies shared across jobseeker pages (viewjob, homepage, SERP etc.)
const JOBSEEKER_READABLE_COOKIES = [
  CookieKey.referral,
  CookieKey.lastVisit,
  CookieKey.dsaCompliant,
  CookieKey.stealthGroups,
  CookieKey.recentSearch,
  // MAGUA app download promo frequency control cookies (shared across jobseeker pages)
  CookieKey.maguaPageVisitsCount,
  CookieKey.maguaPromoShownInSessionCount,
  CookieKey.maguaPromoShownInMonthOrWeekCount,
  CookieKey.maguaPromoClosedInSessionCount,
  CookieKey.maguaPromoClosedInMonthCount,
] as const;

const VIEWJOB_READABLE_COOKIES = [
  ...JOBSEEKER_READABLE_COOKIES,
  CookieKey.previousPageNumber,
  CookieKey.publisherNumber,
  CookieKey.clickTrackingLog,
  CookieKey.desktopClickTrackingLog,
  CookieKey.applyCountHistogram,
] as const;

const emptyViewjobCookies = Object.fromEntries(
  VIEWJOB_READABLE_COOKIES.map((cookie) => [cookie, null]),
) as Record<ViewJobReadableCookies, string | null>;

export type ViewJobReadableCookies = (typeof VIEWJOB_READABLE_COOKIES)[number];

export async function getCookiesForViewJob(
  api: Required<RNCoreNativeModule>,
): Promise<Record<ViewJobReadableCookies, string | null>> {
  const cookies = await api.getCookies(VIEWJOB_READABLE_COOKIES);
  return cookies ?? emptyViewjobCookies;
}

export const HOMEPAGE_READABLE_COOKIES = [
  ...JOBSEEKER_READABLE_COOKIES,
  CookieKey.recentSearch,
] as const;

export type HomepageReableCookies = (typeof HOMEPAGE_READABLE_COOKIES)[number];

export async function getCookiesForHomepage(): Promise<
  Record<HomepageReableCookies, string | null>
> {
  const cookies = await getCookies(HOMEPAGE_READABLE_COOKIES);
  return cookies;
}
